import noop from 'lodash/noop';
import styled from 'styled-components';

import { BodilColor } from '~src/branding';
import { useBranding } from '~src/context/BrandingContext';
import { calculateHoverColor } from '~src/util/color';

import { Heading } from '../Typography';
import { DEFAULT_HEATING_OPTIONS } from './common';
import { Props } from './types';

const Wrapper = styled.div({ padding: '4px' });

const StyledContainer = styled.div({
  backgroundColor: 'transparent',
  display: 'flex',
});

const OptionBox = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 0 0 0',
  width: '90px',
});

const IconBox = styled.div<{ selected?: boolean; darkColor: string; lightColor: string }>(
  ({ selected, darkColor, lightColor }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    border: `1px solid ${BodilColor.greyscale[30]}`,
    marginBottom: '8px',
    borderRadius: '8px',
    backgroundColor: selected ? darkColor : lightColor,
    '&:hover': {
      backgroundColor: selected ? darkColor : calculateHoverColor(lightColor),
    },
  })
);

export const HeatingTypeSelect = ({
  options = DEFAULT_HEATING_OPTIONS,
  onChange,
  label: headerLabel,
  value,
  style,
}: Props) => {
  const { darkColor, lightTextColor } = useBranding();

  return (
    <Wrapper style={style}>
      {headerLabel && <Heading level={4}>{headerLabel}</Heading>}
      <StyledContainer>
        {options.map(({ label, value: optionValue, Icon, SecondaryIcon }) => {
          const selected = value === optionValue;
          const iconSize = SecondaryIcon ? 22 : 42;
          const iconProps = {
            color: selected ? lightTextColor : darkColor,
            width: iconSize,
            height: iconSize,
          };

          return (
            <OptionBox key={optionValue}>
              <IconBox
                {...{
                  selected,
                  onClick: selected ? noop : () => onChange(optionValue),
                  darkColor,
                  lightColor: lightTextColor,
                }}
              >
                {Icon && <Icon {...iconProps} />}
                {SecondaryIcon && <SecondaryIcon {...iconProps} />}
              </IconBox>
              <Heading level={4} style={{ textAlign: 'center' }}>
                {label}
              </Heading>
            </OptionBox>
          );
        })}
      </StyledContainer>
    </Wrapper>
  );
};
